export const TsUtilityFunctions = {
  returnArrayWithNonNullValues(input: any[]): any[] {
    const res: any[] = [];
    for (const item of input) {
      if (item) res.push(item);
    }
    return res;
  },
  wrapValueWithArray(val: any): any[] {
    return val ? [val] : [];
  },
};
